import { COURSE_STATUS } from '@/constants/course-status'
import type { CourseEquivalenceFormType } from '@/schemas/education/match-courses-schema'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'

interface UsedCoursesResult {
  workloadUsed: number
  totalWorkload: number
  coursesUsed: number
  totalCourses: number
}

export function useCourseMetrics() {
  function calculateUsedCourses(equivalences: CourseEquivalenceFormType = []) {
    return equivalences.reduce(
      (acc, equivalence) => {
        const isGranted =
          equivalence.equivalenceStatus?.id === COURSE_STATUS.GRANT.id

        if (isGranted) {
          acc.workloadUsed += equivalence.desiredCourse?.workload ?? 0

          if (
            equivalence.desiredCourse?.courseId
            && equivalence.previousCourse?.name
          ) {
            acc.coursesUsed += 1
          }
        }

        return acc
      },
      { workloadUsed: 0, coursesUsed: 0 }
    )
  }

  function calculateTotalWorkload(desiredCourses: DesiredEducationCourse[]) {
    return desiredCourses.reduce((acc, course) => {
      acc += course.workload
      return acc
    }, 0)
  }

  function calculateMetrics(
    courseEquivalences: CourseEquivalenceFormType,
    desiredCourses: DesiredEducationCourse[]
  ): UsedCoursesResult {
    const { workloadUsed, coursesUsed } =
      calculateUsedCourses(courseEquivalences)

    const totalWorkload = calculateTotalWorkload(desiredCourses)

    return {
      coursesUsed,
      totalCourses: desiredCourses.length,
      workloadUsed,
      totalWorkload
    }
  }

  return { actions: { calculateMetrics } }
}
